var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"button",class:_vm.font ? 'font' : '',style:(_vm.customStyle),attrs:{"color":_vm.color,"dark":_vm.dark,"disabled":_vm.disabled,"loading":_vm.loading,"depressed":"","outlined":_vm.outlined,"height":_vm.height,"width":_vm.width,"aria-label":_vm.ariaLabel},on:{"click":function($event){return _vm.click()}}},[_vm._t("default"),_c('p',{staticClass:"button__content",style:({
      width: _vm.contentWidth,
      'font-size': _vm.fontSize,
      'line-height': _vm.lineHeight,
      margin: _vm.margin,
    })},[_vm._v(_vm._s(_vm.text))])],2)}
var staticRenderFns = []

export { render, staticRenderFns }